// Builds the CSV instructors download from the View Submissions page.

const COLUMNS = ["Student ID", "Topic", "Question", "Attempt", "Status", "Tests Passed", "Timestamp", "Code"];

// Quote every field so commas, quotes and newlines in student code survive.
const csvField = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;

export function submissionsToCsv(submissions, questions = []) {
  const byId = new Map(questions.map((q) => [q.questionID, q]));
  const rows = submissions.map((s) => {
    const question = byId.get(s.qid);
    return [
      s.sid,
      question?.topic,
      question?.functionName ?? s.qid,
      s.attemptNum,
      s.status,
      s.testCasesPassed,
      s.timestamp,
      s.code,
    ];
  });
  return [COLUMNS, ...rows].map((row) => row.map(csvField).join(",")).join("\r\n");
}
